import '@stone-payments/jade-design-tokens/ton/fonts.css'
import '@stone-payments/jade-design-tokens/ton/color.css'
import '@stone-payments/jade-design-tokens/ton/typography.css'
import '@stone-payments/jade-design-tokens/ton/space.css'
import '@stone-payments/jade-design-tokens/ton/bundle.css'
import '@stone-payments/jade-design-tokens/stone/bundle.css'
